export type Props = {
    className?: string;
};

export type StringObj = Record<string, string>;

export type LanguageObj = Record<LocaleType, string>;

export type Menu = {
    id: number;
    name: string;
    url: string;
};

export type Required<T> = {[K in keyof T]-?: NonNullable<T[K]>};

export type RequiredDeep<T> = {
    [K in keyof T]-?: T[K] extends string | number | boolean ? NonNullable<T[K]> : NonNullable<RequiredDeep<T[K]>>;
};

export const PoiKeys: PoiKey[] = [
    'bank',
    'kindergarten',
    'pharmacy',
    'playground',
    'post',
    'public_transport',
    'restaurant',
    'school',
    'shop',
    'sports_field',
];

export type PoiKey =
    | 'bank'
    | 'kindergarten'
    | 'pharmacy'
    | 'playground'
    | 'post'
    | 'public_transport'
    | 'restaurant'
    | 'school'
    | 'shop'
    | 'sports_field';

export type Entries<T> = {
    [K in keyof T]: [K, T[K]];
}[keyof T][];

export function entries<T>(obj: T): Entries<T> {
    return Object.entries(obj) as any;
}

export type Keys<T> = {
    [K in keyof T]: [K];
}[keyof T];

export function keys<T>(obj: T): Keys<T> {
    return Object.keys(obj) as any;
}

export enum LocaleEnum {
    cs = 'cs',
    sk = 'sk',
    en = 'en',
}

export const langOptions: LanguageObj = {
    [LocaleEnum.cs]: 'Čeština',
    [LocaleEnum.sk]: 'Slovenčina',
    [LocaleEnum.en]: 'English',
};

export type LocaleType = 'cs' | 'sk' | 'en';

export const verifyLocale = (locale: string | undefined): LocaleType => {
    switch (locale) {
        default:
        case LocaleEnum.cs:
            return LocaleEnum.cs;

        case LocaleEnum.sk:
            return LocaleEnum.sk;

        case LocaleEnum.en:
            return LocaleEnum.en;
    }
};

export function nonNullArray<T>(arr: T[]): NonNullable<T>[] {
    return arr.filter((i) => !!i) as any;
}

type NonNullableProperties<T, K> = {
    [J in keyof T]: null extends T[J] ? Exclude<T[J], null> | K : T[J];
};

export function nonNullProperties<T, K>(obj: T, defaultValue: K): NonNullableProperties<T, K> {
    const cp = Object.assign({}, obj);
    for (const property in cp) {
        if (cp[property] === null) {
            cp[property] = defaultValue as any;
        }
    }
    return cp as any;
}

type RequiredProperties<T, K extends keyof T> = T & RequiredDeep<Pick<T, K>>;

export function propertyRequiredArray<T, K extends keyof T>(arr: T[], keys: K[]): RequiredProperties<T, K>[] {
    return arr.filter((i) =>
        entries(i).every(([key, value]) => !keys.includes(key as any) || (value !== null && value !== undefined)),
    ) as RequiredProperties<T, K>[];
}

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[] ? ElementType : never;
